import React from 'react';
import { Collapse, Col, Row } from 'react-bootstrap';
import Loading from 'react-loading';
import cn from 'classnames';
import style from './style.scss';
import { TicketSpotContainer } from 'widget/event_components/Ticket/components/TicketSpotContainer';

class TicketPurchasing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      host: window.baseUrl ? new URL(window.baseUrl).hostname : '',
      loading: props.event.get('type') === 'eventbrite',
    };

    if (props.event.get('type') === 'eventbrite') {
      window.addEventListener('message', (event) => {
        if (event.data.messageName === 'widgetRenderComplete' && event.data.eventId === props.event.get('id')) {
          // still a slight delay after receive this
          setTimeout(() => {
            this.setState({ loading: false });
          }, 1000);
        }
      });
    }
  }

  parentParams() {
    return `parent=client.geteventviewer.com&parent=editor.wix.com&parent=${this.state.host}`;
  }

  twitchDisplay = () => {
    const { event, settings } = this.props;
    const twitchDisplay = settings.get('twitchDisplay');
    const params = `parent=client.geteventviewer.com&parent=editor.wix.com&parent=${this.state.host}`;

    const videoUrl = `https://player.twitch.tv?channel=${event.get('user_login')}&${params}`;
    const chatUrl = `https://www.twitch.tv/embed/${event.get('user_login')}/chat?${params}`;
    if (twitchDisplay === 'video') {
      return [videoUrl];
    } else if (twitchDisplay === 'chat') return [chatUrl];

    return [videoUrl, chatUrl];
  };

  render() {
    const { event, open, settings, onResizeComponent } = this.props;
    if (event.get('type') === 'google') return <span />;
    const calendarTypeUrlMapping = {
      eventbrite: [`https://www.eventbrite.com/checkout-external?eid=${event.get('id')}&parent=${window.location.href}`],
      'ticket-tailor': [`${event.get('url')}select-date?modal_widget=true&widget=true`],
      'ovation-tix': [`${event.get('ticket_url')}`],
      'ticket-spice': [`${event.get('ticket_url')}`],
      zoom: [`${event.get('ticket_url')}`],
      twitch: this.twitchDisplay(),
    };

    if (!open) return <span />;

    const isMobile = window.isMobileType;

    const columnSizes = {
      1: [12],
      2: [isMobile ? 12 : 9, isMobile ? 12 : 3],
    };
    const embedUrls = calendarTypeUrlMapping[event.get('type')] || [];
    if (event.get('type') === 'eventviewer' && event.get('use_checkout_form')) {
      return (
        <TicketSpotContainer
          includeImage
          settings={settings}
          event={event}
          onResizeComponent={onResizeComponent}
          isDatetime={this.props.isDatetime}
        />
      );
    }
    return (
      <Collapse style={{ width: '100%' }} in={open} key={event.get('id')}>
        <div className={style.purchasing}>
          <Row>
            {embedUrls.map((url, index) => (
              <Col xs={columnSizes[embedUrls.length][index]}>
                {this.state.loading && (
                  <div className={style.ticketLoader}>
                    <Loading height={40} width={40} type="spin" delay={0} color="#38434B" className="loading-indicator" />
                  </div>
                )}
                {url ? (
                  <iframe
                    frameBorder="0"
                    src={url}
                    className={cn(style.ticketPopup, { [style.popup]: !this.state.loading })}
                    title="Ticket Spot"
                    height="700px"
                    width="100%"
                    allowFullScreen="true"
                  />
                ) : (
                  <span />
                )}
              </Col>
            ))}
          </Row>
        </div>
      </Collapse>
    );
  }
}

export default TicketPurchasing;
